var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('Dropdown',{attrs:{"options":{ placement: _vm.$themeSettings.components.CheckoutLoginDropdown.position },"type":['click'],"hide-by-close-element":true,"trigger":"CheckoutLoginDropdown-link"}},[_c('div',{staticClass:"CheckoutLoginDropdown"},[_c('LoginForm',{attrs:{"redirect-path":_vm.$route.path}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }